var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#FCFAFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04 16V22H5V25H9.56V28H12.6V25H15.64V28H18.68V24.9235C21.6714 24.55 24 22.051 24 19C24 17.02 23.012 15.274 21.5072 14.1805C22.617 13.0645 23.2391 11.5636 23.24 10C23.24 7.213 21.2959 4.8835 18.68 4.213V1H15.64V4H12.6V1H9.56V4H5V7H8.04V16ZM17.92 22H11.08V16H17.92C19.5966 16 20.96 17.3455 20.96 19C20.96 20.6545 19.5966 22 17.92 22ZM11.08 7H17.16C18.8366 7 20.2 8.3455 20.2 10C20.2 11.6545 18.8366 13 17.16 13H11.08V7Z",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/profit-icon.bd0372f494351bc1ccf683df49bd1b35.svg";
export { ForwardRef as ReactComponent };